module.exports = __webpack_public_path__ + "img/SwiftLearner.7c3a7563.png";